import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { useState } from "react";
import { WebCourseFormValues } from "src/models/WebCourse.model";
import { useAddWebcourseMutation } from "src/services/WebcourseServices";
import { showToast } from "src/utils/showToaster";
import { object, string } from "yup";
import WebCourseForm from "../Layout/WebCourseForm";
import { useNavigate } from "react-router-dom";
type Props = {
  onClose: () => void;
};

const AddWebCourseFormWrapper = ({ onClose }: Props) => {
  const [saveNextChecked, setSaveNextChecked] = useState(true);

  const [addWebCourse] = useAddWebcourseMutation();
  const navigate = useNavigate()
  // Form Initial Values
  const initialValues: any = {
    courseName: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    courseName: string().required("Please enter course name"),
  });

  // Handle Submit
  const handleSubmit = (
    values: WebCourseFormValues,
    { setSubmitting, resetForm }: FormikHelpers<WebCourseFormValues>
  ) => {
    const formatedValue = {
      courseName: values.courseName || '',
    };

    addWebCourse(formatedValue).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          navigate(`/website-content/web-course/${res?.data?.data?._id}/details`)
          if (!saveNextChecked) {
            resetForm();
            onClose();
          }
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form className="h-full overflow-hidden contents">
            <WebCourseForm
              formikProps={formikProps}
              onClose={onClose}
              formType="Add"
              setSaveNextChecked={setSaveNextChecked}
              saveNextChecked={saveNextChecked}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddWebCourseFormWrapper;
